import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

export const TICKETS_ENDPOINTS = {
  main: `${BASE_URL}api/tickets/`,
  meta: `${BASE_URL}api/tickets/meta/`,
  byTicketNumber: (id) => `${BASE_URL}api/tickets/${id}/`,
  exportTickets: `${BASE_URL}api/tickets/export_tickets`
};

const ticketListFiltersKey = "ticketListFilters";

class Tickets {
  async getTicket(ticketNumber) {
    const { data, res } = await request({
      url: TICKETS_ENDPOINTS.byTicketNumber(ticketNumber),
      method: "GET",
    });
    return { res, data };
  }
  async getTickets() {
    const { data, res } = await request({
      url: TICKETS_ENDPOINTS.main,
      method: "GET",
    });
    return data;
  }
  async editOrCreateTicket(id = null, payload = {}) {
    const isEdit = id && id !== "create";
    const { res, data } = await request({
      url: isEdit
        ? TICKETS_ENDPOINTS.byTicketNumber(id)
        : TICKETS_ENDPOINTS.main,
      method: isEdit ? "PUT" : "POST",
      body: payload,
    });
    return { res, data };
  }

  readListFilters() {
    return JSON.parse(localStorage.getItem(ticketListFiltersKey) || "{}");
  }

  async storeListFilters(filters) {
    localStorage.setItem(ticketListFiltersKey, JSON.stringify(filters));
  }

  async clearListFilters() {
    localStorage.removeItem(ticketListFiltersKey);
  }
}

export const TicketsService = new Tickets();
